import React from "react";
import { useSelector } from "react-redux";

export default function UserIsLoggedInAs() {
	const email = useSelector(state => state.user.email);
	const name = useSelector(state => state.user.name);

	return(<p>You are logged in as <b>{name.length > 0 ? name+', ' : ''}{email}</b></p>);
}
